import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import cx from 'classnames';
import { createSelector } from 'reselect';
import * as yup from 'yup';

import { getParam } from 'utils/url';
import { Urls } from 'constants/constants';

import User from '../store/models/User';
import UIState from '../store/UIState';
import { history } from 'store/RouteState';

import { ContentCenter, SectionTitle } from 'components/Content';
import ScrollToTop from 'components/ScrollToTop';
import TextInput from 'components/forms/TextInput';
import { Form } from 'components/forms/Form';
import { ButtonListCenter, Button } from 'components/Button';
import { ServerErrors } from 'components/forms/Error';

// ======================
// HELPERS
// ======================



const schema = yup.object().shape({
  password: yup
    .string()
    //.min(5)
    .required('Password is required'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords do not match')
    .required('Confirm Password is Required'),
});



// ======================
// STORE
// ======================
const selector = createSelector(
  () => {
    return { 
    
    }
  },
);


// ======================
// COMPONENT
// ====================== 
export const ResetPasswordScreen = ({ match,...props}) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [edits, setEdits] = useState({});
  const [savingPassword, setSavingPassword] = useState(false);
  const token = getParam('t');
  const userId = getParam('u');
  
  useEffect(() => {
    (async () => {
      setLoading(true);
      setLoading(false);
    })();
  }, [])

  const onChange = (value, name) => {
    setValues({...values, [name]: value});
    setEdits({...edits, [name]: true});
  }

  const onSubmit = async () => {
    let v;
    setSavingPassword(true);
    try {
      v = await schema.validate(values, {abortEarly: false});
    } catch(err) {
      setSavingPassword(false);
      setErrors(_.reduce(err.inner, (acc, e) => _.set(acc, e.path, e.errors), {}));
      return;
    }
    try {
      await dispatch(User.actions.resetPassword(v.password, userId, token));
      dispatch(UIState.actions.showSuccessToast("Your password has been changed"));
      history.push(Urls.HOME);
    } catch (err) {
      setErrors({server: err.message});
    } finally {
      setSavingPassword(false);
    }
  }

  return <>
    <ScrollToTop />
    <ContentCenter className="reset-password">
      <h2>Enter A New Password</h2>
      <ServerErrors errors={errors} />
      <Form onSubmit={onSubmit}>
        <TextInput
          label="New Password"
          name="password"
          type="password"
          value={values.password}
          errors={errors.password}
          onSubmit={onSubmit}
          onChange={onChange}/>
        <TextInput
          label="Confirm Password"
          name="passwordConfirm"
          type="password"
          value={values.passwordConfirm}
          errors={errors.passwordConfirm}
          onSubmit={onSubmit}
          onChange={onChange}/>
      </Form>
      <ButtonListCenter className="reset-action">
        <Button size="l" onClick={onSubmit} loading={savingPassword}>Save Password</Button>
      </ButtonListCenter>
    </ContentCenter>
  </>
}
export default ResetPasswordScreen